import "../components/global.js";
import "../assets/css/bootstrap.css";
import Navbar from "../components/Navbar.js";
import { tokens, success_url, alert, toFixed, POST, format_date, getStorage, loading } from "../components/CustomComponent.js";
import React, { Component } from "react";
import { ReactExcel, readFile, generateObjects } from "@ramonak/react-excel";
import excel_file from "../assets/files/import_customer.xlsx";

const STATUS_TRANS_MAP = { "โอนกรรมสิทธิ์แล้ว": 1, "ยังไม่โอนกรรมสิทธิ์": 2, "ห้องว่าง": 3 };
const BUY_BUILD_MAP = { "เงินสด": 1, "ผ่อนชำระกับธนาคาร": 2, "ผู้เช่าซื้อกับการเคหะแห่งชาติ": 3, "ซื้อต่อกับลูกค้าเดิม": 4, "อื่น ๆ": 5 };

const GET_TRANS_TXT = (val) => Object.keys(STATUS_TRANS_MAP).find(k => STATUS_TRANS_MAP[k] === val) || "-";
const GET_BUY_TXT = (val) => Object.keys(BUY_BUILD_MAP).find(k => BUY_BUILD_MAP[k] === val) || "-";

export default class Import extends Component {
  state = { import: null, currentSheet: null, over: false, data_import: null, visible: false };

  componentDidMount() {
    loading(false); // เรียกใช้งานทันทีตั้งแต่เข้ามาหน้าแรก
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const isVisible = window.pageYOffset > 300;
    if (isVisible !== this.state.visible) this.setState({ visible: isVisible });
  };

  scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  Create_Import = async () => {
    loading(true);
    let result = await POST(tokens, `v1/TH/customer-manage/create/${getStorage("project_id")}`, { customer_list: this.state.data_import });
    if (result?.status) success_url("/customer");
    loading(false);
  };

  handleFile = (file) => {
    readFile(file).then((readedData) => {
      if (readedData.SheetNames[0] === "นำเข้าข้อมูลลูกค้า") {
        this.setState({ import: readedData }, () => setTimeout(this.Import, 10));
      } else alert("info", "แจ้งเตือน", "ไฟล์ไม่ถูกต้อง");
    }).catch(console.error);
  };

  Import_file = (e) => {
    if (e.target.files[0]) this.handleFile(e.target.files[0]);
    e.target.value = "";
  };

  drop_file = (e) => {
    e.preventDefault();
    this.setState({ over: false });
    const file = e.dataTransfer.items[0]?.getAsFile();
    if (file) this.handleFile(file);
  };

  Import = () => {
    loading(true);
    const headers = ["ชื่อ - สกุล", "เลขบัตรประชาชน", "ที่อยู่", "โทรศัพท์บ้าน", "โทรศัพท์มือถือ", "วันที่ส่งมอบ(ช่องกรอก)", "วันที่ส่งมอบ", "วันที่มารับมอบ(ช่องกรอก)", "วันที่มารับมอบ", "วันที่โอน(ช่องกรอก)", "วันที่โอน", "สถานะการโอน", "เลขที่เงินกู้", "วงเงินกู้", "เงินงวด", "วันที่ทำสัญญา(ช่องกรอก)", "วันที่ทำสัญญา", "ซื้ออาคารโดย", "อาคาร", "ชั้น", "บ้านเลขที่", "ขนาดห้อง (ตรม.)"];
    const sheetHeaders = this.state.currentSheet["นำเข้าข้อมูลลูกค้า"][0];
    
    // ตรวจสอบ Header
    const invalidIdx = headers.findIndex((h, i) => h !== sheetHeaders[i]);
    if (invalidIdx !== -1) {
      alert("warning", "แจ้งเตือน", `หัวคอลัมน์ "${headers[invalidIdx]}" ไม่ถูกต้อง`);
      loading(false);
      return;
    }

    const data = generateObjects(this.state.currentSheet)
      .filter(item => item["ชื่อ - สกุล"] && item["ชื่อ - สกุล"] !== "ตัวอย่าง ข้อมูล") // กรองตัวอย่างข้อมูลออกทันที
      .map(item => ({
        full_name: item["ชื่อ - สกุล"]?.toString().trim() || "",
        id_card: item["เลขบัตรประชาชน"] ? ("000000" + item["เลขบัตรประชาชน"]).slice(-13) : "",
        address: item["ที่อยู่"] || "",
        home_phone: (item["โทรศัพท์บ้าน"] || "").toString().replace(/-/g, ""),
        mobile_phone: item["โทรศัพท์มือถือ"] ? ("000" + item["โทรศัพท์มือถือ"]).replace(/-/g, "").slice(-10) : "",
        delivery_date: item["วันที่ส่งมอบ"] || null,
        receive_date: item["วันที่มารับมอบ"] || null,
        transfer_date: item["วันที่โอน"] || null,
        status_transfer: STATUS_TRANS_MAP[item["สถานะการโอน"]] || 0,
        loan_number: (item["เลขที่เงินกู้"] || "").toString(),
        credit_limit: item["วงเงินกู้"] || 0,
        installment: item["เงินงวด"] || 0,
        contract_date: item["วันที่ทำสัญญา"] || null,
        status_buy_building: BUY_BUILD_MAP[item["ซื้ออาคารโดย"]] || 0,
        address_number: (item["บ้านเลขที่"] || "").toString(),
        building: item["อาคาร"] || "",
        floor: item["ชั้น"] || "",
        room_size: item["ขนาดห้อง (ตรม.)"] || "",
        status_cable: false,
      }));

    this.setState({ data_import: data.length ? data : null });
    loading(false);
  };

  render() {
    const { data_import, over, visible } = this.state;
    const tdL = (val) => <td className={val ? "text-left" : "text-left bg-danger-light"}>{val || "-"}</td>;
    const dateFmt = (d) => <td className="text-left">{d ? format_date(d, "dd/mm/yyyy") : "-"}</td>;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="รายชื่อลูกค้า" />
        <div className="body">
          <div className="p-3">
            <div className="w-100 d-flex justify-content-between mb-3">
              <h4 className="mb-3"><b>นำเข้าไฟล์ข้อมูล : รายชื่อลูกค้า</b></h4>
              <div className="d-flex">
                <button className="btn btn-outline-primary wpx-150 mx-1" onClick={() => window.location.href = "/import"}><span className="icon-brand mr-2">{"\uf060"}</span>ย้อนกลับ</button>
                {data_import && <button className="btn btn-danger wpx-150 mx-1" onClick={() => this.setState({ data_import: null })}>ล้างค่า</button>}
                {data_import && <button className="btn btn-primary wpx-150 mx-1" onClick={this.Create_Import}>นำเข้า</button>}
              </div>
            </div>

            {!data_import ? (
              <div className="card border-0 p-3 mb-3">
                <div className="w-100 text-right">
                  <a className="text-primary mt-3" href={excel_file} download="import_customer.xlsx"><label className="icon">{"\uf65b"}</label> template นำเข้าข้อมูลลูกค้า</a>
                </div>
                <div className={`card py-5 border-dashed align-items-center ${over ? "bg-blue-sky" : "bg-light"}`}
                  onDrop={this.drop_file} onDragOver={(e) => { e.preventDefault(); this.setState({ over: true }); }} onDragLeave={(e) => { e.preventDefault(); this.setState({ over: false }); }}>
                  <b className="icon text-primary mt-4" style={{ fontSize: 48 }}>{"\uf56f"}</b>
                  <b className="text-secondary">ลากและวางไฟล์ที่นี่</b>
                  <small className="text-secondary mb-3">หรือ</small>
                  <button className="btn btn-primary wpx-120 mb-4" onClick={() => document.getElementById("file").click()}>เลือกไฟล์</button>
                  <input className="d-none" type="file" id="file" accept=".xls,.xlsx" onChange={this.Import_file} />
                </div>
              </div>
            ) : (
              <div className="card border-0 mb-3">
                <div className="card-header bg-dark-blue px-3 rounded-top"><h4 className="text-white mb-0"><b>ข้อมูลนำเข้า</b></h4></div>
                <div className="p-3">
                  <label>จำนวนที่นำเข้า {data_import.length} รายการ</label>
                  <div className="table-responsive">
                    <table className="table text-nowrap">
                      <thead>
                        <tr className="bg-dark-blue text-white">
                          <th className="text-left wpx-150">ชื่อ - สกุล</th><th>เลขบัตรประชาชน</th><th className="wpx-200">ที่อยู่</th>
                          <th>โทรศัพท์บ้าน</th><th>โทรศัพท์มือถือ</th><th>วันที่ส่งมอบ</th><th>วันที่มารับมอบ</th><th>วันที่โอน</th>
                          <th className="wpx-120">สถานะการโอน</th><th>เลขที่เงินกู้</th><th>วงเงินกู้</th><th>เงินงวด</th><th>วันที่ทำสัญญา</th>
                          <th className="wpx-170">ซื้ออาคารโดย</th><th>อาคาร</th><th>ชั้น</th><th>บ้านเลขที่</th><th>ขนาดห้อง (ตรม.)</th><th>ลบ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data_import.map((item, i) => (
                          <tr key={i}>
                            {tdL(item.full_name)}
                            <td className="text-left">{item.id_card || "-"}</td>
                            <td className="text-left">{item.address || "-"}</td>
                            <td className="text-left">{item.home_phone || "-"}</td>
                            <td className="text-left">{item.mobile_phone || "-"}</td>
                            {dateFmt(item.delivery_date)}{dateFmt(item.receive_date)}{dateFmt(item.transfer_date)}
                            <td className="text-left">{GET_TRANS_TXT(item.status_transfer)}</td>
                            <td className="text-left">{item.loan_number || "-"}</td>
                            <td className="text-left">{item.credit_limit ? toFixed(item.credit_limit) : "-"}</td>
                            <td className="text-left">{item.installment ? toFixed(item.installment) : "-"}</td>
                            {dateFmt(item.contract_date)}
                            <td className="text-left">{GET_BUY_TXT(item.status_buy_building)}</td>
                            {tdL(item.building)}{tdL(item.floor)}{tdL(item.address_number)}
                            <td className="text-left">{item.room_size || "-"}</td>
                            <td className="text-center">
                              <label className="wpx-24 hpx-24 bg-danger-light rounded-1 d-flex align-items-center justify-content-center mx-auto mb-0 pointer" onClick={() => {
                                const newData = data_import.filter((_, idx) => idx !== i);
                                this.setState({ data_import: newData.length ? newData : null });
                              }}>
                                <span className="icon text-danger">{"\uf2ed"}</span>
                              </label>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
            <div className="d-none"><ReactExcel initialData={this.state.import} onSheetUpdate={(s) => this.setState({ currentSheet: s })} activeSheetClassName="d-none" /></div>
          </div>
        </div>
        {visible && <button className="position-fixed btn btn-primary" onClick={this.scrollToTop} style={{ bottom: 30, right: 30, zIndex: 100 }}>กดเพื่อไปยังด้านบน</button>}
      </div>
    );
  }
}